import React from "react";
import CANCEL from "../../../assets/images/cancel-trip.png";
import { useAppSelector } from "../../../app/hooks";
import moment from "moment";
import { FaArrowRightArrowLeft, FaArrowRightLong } from "react-icons/fa6";
import { getFlightImage } from "../../../_helpers/flightUtils";
import INDIGO from "../../../assets/images/INDIGO.png";
import { useNavigate } from "react-router";
import { FlightImage } from "../../../components/flightimage/FlightImage";

const CancelledTrips = () => {
  const MytripsList = useAppSelector((state) => state.mytrips.MytripsList);

  const navigate = useNavigate();

  return (
    <div
      className="tab-pane fade"
      id="pills-cancelled-flight"
      role="tabpanel"
      aria-labelledby="pills-cancelled-flight-tab"
    >
      {MytripsList && MytripsList.cancelled?.length > 0 ? (
        MytripsList.cancelled.map((item: any, index: any) => {
          const isOneWayTrip = item?.flight_type === "ONEWAY";

          return (
            <div className="flight-card-wrapper">
              <div className="flight-header">
                <div>
                  <div className="flight-header-wrapper">
                    <h2>
                      {item?.departure_airport}
                      <span className="me-2 ms-2">
                        {isOneWayTrip ? (
                          <FaArrowRightLong />
                        ) : (
                          <FaArrowRightArrowLeft />
                        )}
                      </span>
                      {item?.arrival_airport}
                    </h2>
                    {isOneWayTrip && (
                      <span className="day-badge ms-2 cancelled">
                        Cancelled
                      </span>
                    )}
                  </div>
                  <p className="flight-status">
                    <strong>
                      {isOneWayTrip ? "One Way Flight" : "Round Trip Flight"}
                    </strong>{" "}
                    • Booking Ref. No. -{" "}
                    <strong>{item?.portal_booking_no}</strong>
                  </p>
                </div>
                <button
                  onClick={() => {
                    navigate(
                      `/flights/cancelled-trip-details?bookingId=${item?.portal_booking_no}`
                    );
                  }}
                  className="fill-btn manage-btn"
                >
                  View & Manage Booking
                </button>
              </div>
              <div className="flight-body">
                {!isOneWayTrip && (
                  <div className="w-100 mb-1">
                    <span className="flight-type">Departure Flight</span>
                    <span className="depart-time">
                      {" "}
                      -{" "}
                      {moment(
                        item?.onwardDetails?.departure_date_time,
                        "MM/DD/YYYY HH:mm:ss"
                      ).format("ddd, DD MMM")}
                    </span>
                    <span className="day-badge ms-2 cancelled">Cancelled</span>
                  </div>
                )}
                <div className="flight-section">
                  {isOneWayTrip && <p className="label">From</p>}
                  <p className="time">
                    {moment(
                      item?.onwardDetails?.departure_date_time,
                      "MM/DD/YYYY HH:mm:ss"
                    ).format("DD MMM 'YY hh:mm A")}
                  </p>
                  <p className="airport">
                    {item?.onwardDetails?.departure_airport}
                  </p>
                </div>
                <div className="flight-section">
                  {isOneWayTrip && <p className="label">To</p>}
                  <p className="time">
                    {moment(
                      item?.onwardDetails?.arrival_date_time,
                      "MM/DD/YYYY HH:mm:ss"
                    ).format("DD MMM 'YY hh:mm A")}
                  </p>
                  <p className="airport">
                    {item?.onwardDetails?.arrival_airport}
                  </p>
                </div>
                <div className="flight-section airline-passenger">
                  <FlightImage
                    key={item?.onwardDetails?.airline_code}
                    flightCode={item?.onwardDetails?.airline_code}
                    style={{ height: 40, width: 40 }}
                  />
                  <p className="m-0">
                    {item?.onwardDetails?.airline_name}
                    {", "}
                    <strong>{item?.onwardDetails?.flight_no}</strong>
                  </p>
                </div>
                <div className="flight-section last-col"></div>
              </div>
              {item?.returnDetails && (
                <div className="flight-body pt-0">
                  {!isOneWayTrip && (
                    <div className="w-100 mb-1">
                      <span className="flight-type">Return Flight</span>
                      <span className="depart-time">
                        {" "}
                        -{" "}
                        {moment(
                          item?.returnDetails?.departure_date_time,
                          "MM/DD/YYYY HH:mm:ss"
                        ).format("ddd, DD MMM")}
                      </span>
                      <span className="day-badge ms-2 cancelled">
                        Cancelled
                      </span>
                    </div>
                  )}
                  <div className="flight-section">
                    {isOneWayTrip && <p className="label">From</p>}
                    <p className="time">
                      {moment(
                        item?.returnDetails?.departure_date_time,
                        "MM/DD/YYYY HH:mm:ss"
                      ).format("DD MMM 'YY hh:mm A")}
                    </p>
                    <p className="airport">
                      {item?.returnDetails?.departure_airport}
                    </p>
                  </div>
                  <div className="flight-section">
                    {isOneWayTrip && <p className="label">To</p>}
                    <p className="time">
                      {moment(
                        item?.returnDetails?.arrival_date_time,
                        "MM/DD/YYYY HH:mm:ss"
                      ).format("DD MMM 'YY hh:mm A")}
                    </p>
                    <p className="airport">
                      {item?.returnDetails?.arrival_airport}
                    </p>
                  </div>
                  <div className="flight-section airline-passenger">
                    <FlightImage
                      key={item?.returnDetails?.airline_code}
                      flightCode={item?.returnDetails?.airline_code}
                      style={{ height: 40, width: 40 }}
                    />
                    <p className="m-0">
                      {item?.returnDetails?.airline_name}
                      {", "}
                      <strong>{item?.returnDetails?.flight_no}</strong>
                    </p>
                  </div>
                  <div className="flight-section last-col"></div>
                </div>
              )}
            </div>
          );
        })
      ) : (
        <div className="upcoming-trips">
          <img src={CANCEL} alt="cancel-trip" />
          <h3>Looks empty, you've no cancelled bookings.</h3>
          <p>When you cancel a trip, you will see your itinerary here.</p>
        </div>
      )}
    </div>
  );
};

export default CancelledTrips;
